<main class="dashboard">
    <div class="row w-100 justify-content-center">
        <div class="col-11">
            <app-dashboard-admin-assignors></app-dashboard-admin-assignors>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>
</main>